<template>
  <div>
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="add()" v-if="hasBtn('btn_add')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border row-key="id" size="mini">
      <el-table-column prop="name" align="center" :label="$t('sale_index.name')"></el-table-column>
      <el-table-column prop="email" align="center" :label="$t('sale_index.email')"></el-table-column>
      <el-table-column :label="$t('index.operation')" align="center" width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row)">{{$t('index.del')}}</el-button>
          <el-button size="mini" type="primary"><router-link :to="{path:'/system_sale_record',query: {id:scope.row.id}}">{{$t('sale_index.sales_record')}}</router-link></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination">
		<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
    <el-dialog :title="$t('index.dialog_title')" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-row class="tree-content" :gutter="20">
        <el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
          <el-col :span="12">
            <el-form-item :label="$t('sale_index.user_name')" prop="user_name">
              <el-input v-model="editForm.user_name" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="is_co==1">
            <el-form-item :label="$t('sale_index.country')" prop="country">
              <el-select v-model="editForm.country" class="w100" :placeholder="$t('index.select')">
                <el-option :label="lang=='cn'?item.name_cn:item.name" v-if="item.code!='co'" :value="item.code" :key="index" v-for="(item,index) in DATA_RIGHTS"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12" v-if="editForm.id">
            <el-form-item :label="$t('sale_index.password')" prop="">
              <el-input v-model="password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!editForm.id">
            <el-form-item :label="$t('sale_index.password')" prop="password">
              <el-input v-model="editForm.password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!editForm.id">
            <el-form-item :label="$t('sale_index.re_password')" prop="re_password">
              <el-input v-model="editForm.re_password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('sale_index.name')" prop="name">
              <el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('sale_index.email')" prop="email">
              <el-input v-model="editForm.email" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed: {
		rules(){
			return{
				user_name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('sale_index.user_name'),
					trigger: 'blur'
				},
                { 
                    min: 3,
                    message: this.$t('sale_index.user_name3'),
                    trigger: 'blur' 
                }],
				// country: [{
				// 	required: true,
				// 	message:  this.$t('index.select') + this.$t('sale_index.country'),
				// 	trigger: 'change'
				// }],
				password: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('sale_index.password'),
					trigger: 'blur'
				},
                { 
                    min: 3,
                    message: this.$t('sale_index.password3'),
                    trigger: 'blur' 
                }],
				email: [{
					required: true,
					message: this.$t('sale_index.email'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('sale_index.name'),
					trigger: 'blur'
				},
                { 
                    min: 3,
                    message: this.$t('sale_index.name3'),
                    trigger: 'blur' 
                }],
			}
		},
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('home.confirm_password')));
			} else {
				if (value==this.editForm.password) {
					callback();
				} else {
					return callback(new Error(this.$t('home.two_passwords')))
				}
			}
		};
		return {
			is_co:sessionStorage.getItem('is_co'),
			list: [],
			roleList: [],
			editFormVisible: false,
			editForm: {
				user_name: '',
				password: '',
				re_password: '',
				role_id: '',
				email: '',
				name: '',
				is_seller: 1,
			},
			editFormRules: {
				re_password: [{
					required: true,
					trigger: 'blur',
					validator: validatorEmail,
				}],
			},
			password:'',
			filters: {},
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
			DATA_RIGHTS:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.editFormRules=Object.assign(this.rules,this.editFormRules);
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:"DATA_RIGHTS"
			};
			this_.$post(url, datas).then((res) => {
				this_.DATA_RIGHTS = res.DATA_RIGHTS;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "sellerList";
			var datas = {
				page:this_.pages.page,
				num:this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count=res.sum;
			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					user_name: '',
					name: '',
					email: '',
					password: '',
					re_password: '',
					// country: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						user_name: this_.editForm.user_name,
						name: this_.editForm.name,
						email: this_.editForm.email,
						country:'us',
						is_seller:1,
						role_id:0,
					}
					var url = "addUser";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.user_id;
						tishi = this_.$t('index.modify_success');
						url = "changeAdmin";
					} else {
						datas['password'] = this_.editForm.password;
						datas['re_password'] = this_.editForm.re_password;
					}
					if (this_.password&&this_.editForm.id) {
						datas['password'] = this_.password;
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.password='';
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "sellerDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel { 
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/sale_index.vue